import React from "react";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function LeadFormSuccess() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
    >
      <Stack alignItems="center" spacing={3} sx={{ py: 6 }}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 260,
            damping: 15,
            delay: 0.1,
          }}
        >
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 12px 40px rgba(16,185,129,0.35)",
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 52, color: "#fff" }} />
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Typography
            variant="h5"
            fontWeight={700}
            align="center"
            sx={{ color: "#059669" }}
          >
            Cadastro enviado com sucesso!
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45 }}
        >
          <Typography
            variant="body1"
            color="text.secondary"
            align="center"
            sx={{ maxWidth: 400 }}
          >
            Recebemos suas informações. Nossa equipe entrará em contato
            pelo WhatsApp para apresentar a Slapie e como podemos ajudar seu negócio.
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.65 }}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            Fique de olho no seu WhatsApp!
          </Typography>
        </motion.div>
      </Stack>
    </motion.div>
  );
}
